<template>
  <div class="method-code">
    <div class="code-card">
      <div class="code-card__icon">
        <feather-icon icon="GiftIcon" size="28" />
      </div>

      <h4 class="code-card__title">Voucher / Gift Code</h4>

      <div class="code-card__steps">
        <div class="code-card__step">
          <span class="code-card__step-num">1</span>
          Enter your code below
        </div>
        <div class="code-card__step">
          <span class="code-card__step-num">2</span>
          Press the button to add credit
        </div>
      </div>

      <b-form-input
        v-model="amount"
        class="code-card__input mb-1"
        placeholder="Paste your code here"
        size="lg"
        trim
        :disabled="loading"
        @keyup.enter="getResponse"
      />

      <b-button
        variant="success"
        size="lg"
        block
        :disabled="!amount || loading"
        @click="getResponse"
      >
        <b-spinner v-if="loading" small class="mr-50" />
        <feather-icon v-else icon="CheckCircleIcon" class="mr-50" />
        {{ loading ? 'Please wait...' : 'Add Credit Now' }}
      </b-button>


      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
import {
  BButton,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";

export default {
  components: {
    BButton,
    BFormInput,
    BSpinner,
  },
  data: () => ({
    amount: "",
    loading: false,
  }),
  methods: {
    ...mapMutations(["HANDLE_CREDIT"]),
    async getResponse() {
      if (!this.amount || this.loading) return;
      this.loading = true;
      try {
        const response = await axios.get(
          `https://alpha.imeicheck.com/api/deposit/code/${this.amount}`,
          {
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.data.status === undefined) {
          this.$swal({
            icon: "error",
            title: "Something went wrong",
            text: "Please try again or contact support.",
            customClass: { confirmButton: "btn btn-primary" },
            buttonsStyling: false,
          });
          this.loading = false;
          return;
        }

        if (response.data.status === "success") {
          this.HANDLE_CREDIT(+response.data.credit);
          this.amount = "";
        }

        this.$swal({
          icon: `${response.data.status}`,
          title: `${response.data.title}`,
          showConfirmButton: false,
          showCloseButton: true,
          timer: 2500,
        });
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "Code not valid",
          text: error.response?.data?.message || "Please check your code and try again.",
          customClass: { confirmButton: "btn btn-primary" },
          buttonsStyling: false,
        });
      }
      this.loading = false;
    },
  },
  mounted() {
    if (this.$route.query.voucher && this.$route.query.voucher !== "") {
      this.amount = this.$route.query.voucher;
      this.getResponse();
    }
  },
};
</script>

<style lang="scss" scoped>
.method-code {
  display: flex;
  justify-content: center;
}

.code-card {
  width: 100%;
  max-width: 440px;
  text-align: center;
  border: 1px solid rgba(115, 103, 240, 0.2);
  border-radius: 16px;
  padding: 2rem 1.5rem;
  background: rgba(115, 103, 240, 0.03);

  &__icon {
    width: 56px;
    height: 56px;
    border-radius: 14px;
    background: rgba(40, 199, 111, 0.12);
    color: #28c76f;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 1rem;
  }

  &__title {
    font-weight: 700;
    margin-bottom: 1rem;
  }

  &__steps {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 1.5rem;
  }

  &__step {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    font-size: 14px;
    text-align: left;
  }

  &__step-num {
    width: 24px;
    height: 24px;
    min-width: 24px;
    border-radius: 50%;
    background: rgba(40, 199, 111, 0.15);
    color: #28c76f;
    font-weight: 700;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__input {
    text-align: center;
    font-size: 16px;
    letter-spacing: 1px;
    font-weight: 600;
  }

  &__note {
    margin-top: 1.25rem;
    font-size: 12px;
    opacity: 0.55;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
